import React from 'react';
import type { IconsProps } from '@makemydeal/dr-sales-checkin-types';
import { StyledSendToDeskIcon } from './sendToDeskIcon.style';

/** Diagonal "open/send outward" arrow shown on the Send to Desk nav button. */
export const SendToDeskIcon: React.FC<IconsProps> = ({ fill = '#FFFFFF' }) => (
    <StyledSendToDeskIcon
        data-testid="send-to-desk-icon"
        width="10"
        height="10"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.5 0H4.5C4.22375 0 4 0.22375 4 0.5V1.5C4 1.77625 4.22375 2 4.5 2H8.29289L0.646447 9.64645C0.451184 9.84171 0.451184 10.1583 0.646447 10.3536L1.64645 11.3536C1.84171 11.5488 2.15829 11.5488 2.35355 11.3536L10 3.70711V7.5C10 7.77625 10.2238 8 10.5 8H11.5C11.7762 8 12 7.77625 12 7.5V0.5C12 0.22375 11.7762 0 11.5 0Z"
            fill={fill}
        />
    </StyledSendToDeskIcon>
);
